import clsx from "clsx";
import { Button, Icon } from "@/shared/ui";

type Props = {
  title: string;
  description: string;
  onClick: () => void;
  background?: string;
  isBackground?: boolean;
};

export default function DeviceChangeButton({
  title,
  description,
  onClick,
  background,
  isBackground,
}: Props) {
  return (
    <Button
      variant="soft"
      className="flex justify-start items-center gap-2.5 h-14.5 mt-auto px-3.5 bg-dark-800/50 hover:brightness-110"
      style={{ background: background && background }}
      onClick={onClick}
      sound="none"
    >
      <Icon category="home-menu" name="arrows-left-right" className="w-[1rem]" />
      <div className="flex flex-col items-start">
        <p>{title}</p>
        <p
          className={clsx(
            "text-14 font-medium normal-case",
            isBackground ? "text-white/80" : "text-white/30",
          )}
        >
          {description}
        </p>
      </div>
    </Button>
  );
}
